/**
 * @module FieldControls
 */

/**
 * Field control that represents obsolete fieldcontrols.
 */
export const EmptyFieldControl = () => {
  return null
}
